import React from 'react';
import CloseIcon from './CloseIcon';

/**
 * Removable tag / pill atom.
 */
export default function Tag({ label, onRemove, className = '' }) {
  return (
    <span className={`ca-tag ${className}`.trim()}>
      {label}
      {onRemove ? (
        <button
          type="button"
          className="ca-tag__remove"
          onClick={onRemove}
          aria-label={`Remove ${label}`}
        >
          <CloseIcon size={10} />
        </button>
      ) : null}
    </span>
  );
}
